import React from 'react';
import { Typography,Box, Card, CardContent } from '@mui/material';
const InfoCard = ({ icon, text }) => (
        <Card
        sx={{
        height: '100%',
        borderRadius: 3,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        padding: '1.2rem 0 0 0',
        cursor: "pointer",
        transition: "transform 0.3s, box-shadow 0.3s",
        "&:hover": {
            transform: "translateY(-5px)",
            boxShadow: "0 8px 20px rgba(0,0,0,0.15)"
        },
        }}
    >
        <Box
        sx={{
            width: 50,
            height: 50,
            borderRadius: "50%",
            backgroundColor: "#fff",
            border: "6px solid #4FA9E2",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            marginBottom: 0.4,
        }} 
        >
        <Box sx={{ position: "absolute", inset: 6, border: "2px solid #fff", borderRadius: "50%" }} />
        <Box sx={{ zIndex: 1 }}>
            {React.cloneElement(icon, { sx: { ...icon.props.sx, fontSize: 38 } })}
        </Box>
        </Box>
        <CardContent 
            sx={{
                paddingBottom: "0px !important",
            }}
        >
            <Typography variant="body1" sx={{
                fontSize: '14px',
                maxWidth: '188px',
                minHeight: 20
            }}>{text}</Typography>
        </CardContent>
    </Card>
);

export default InfoCard;